module.exports = __webpack_public_path__ + "img/cfad69ded1328be0227b5759248159f8.svg";